import _pull from 'lodash/pull';

function getContextProp(context, name) {
	if (!context) return undefined;
	if (context[name] !== undefined) return context[name];
	if (context.node?.props?.[name] !== undefined) return context.node.props[name];
	if (context.attrs?.[name] !== undefined) return context.attrs[name];
	return undefined;
}

export default {
	props: {
		context: {
			type: Object,
			required: true
		},
	},

	mounted() {
		this.selected = [...(this.currentValue || [])];

		if (this.context.node && !Array.isArray(this.context.node.value)) {
			this.context.node.input([], false);
		}
	},

	data() {
		return {
			selected: []
		};
	},

	computed: {
		fieldOptions() {
			const options = getContextProp(this.context, 'options');
			return Array.isArray(options) ? options : [];
		},
		showColors() {
			return !!getContextProp(this.context, 'colors');
		},
		colorLookup() {
			const colors = getContextProp(this.context, 'colors');
			return colors && typeof colors === 'object' ? colors : {};
		},
		showIcons() {
			return getContextProp(this.context, 'icons');
		},
		currentValue() {
			return this.context._value ?? this.context.value ?? [];
		},
		vModel: {
			get() {
				return this.currentValue;
			}
		}
	},

	methods: {
		optionColor(option) {
			const direct = option.color || option.attrs?.color;
			if (direct && direct !== true) return direct;

			const lookup = this.colorLookup;
			return (
				lookup[option.machineName] ||
				lookup[option.value] ||
				lookup[option.id] ||
				lookup[option.uuid] ||
				lookup[option.label] ||
				lookup[option.name] ||
				''
			);
		},

		colorClass(option) {
			const isUuid = (value) =>
				/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
					String(value),
				);
			const raw = [
				option.machineName,
				option.urlKey,
				option.name,
				option.label,
				option.value,
			].find((value) => value && !isUuid(value));

			return String(raw || '')
				.toLowerCase()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.split(/[^a-z0-9]+/)
				.filter(Boolean)[0] || '';
		},

		onOptionClick(val) {
			if(this.selected.indexOf(val) > -1) {
				_pull(this.selected, val);
			} else {
				this.selected.push(val);
			}
			if (this.context.node && typeof this.context.node.input === 'function') {
				this.context.node.input([...this.selected]);
			} else if (this.context.handlers && typeof this.context.handlers.input === 'function') {
				this.context.handlers.input([...this.selected]);
			}
		}
	},

	watch: {
		vModel(val) {
			if(!val || !val.length) {
				this.selected = [];
			} else {
				this.selected = [...val];
			}
		},
		fieldOptions() {
			// allow options to populate after async taxonomy fetch
		}
	}
};
